<template>
    <Fragment>
        <Portal to="header-actions">
            <AntButton
                icon="plus"
                type="primary"
                @click="$router.push({ name: 'customers.create' })"
            >
                {{ $t('add') }}
            </AntButton>
        </Portal>
        <Card>
            <CustomerTable
                :customers="customers"
                :pagination="pagination"
                :loading="loading"
                @change="fetchResources"
            />
        </Card>
    </Fragment>
</template>

<script>
import CustomerTable from '@/components/tables/CustomerTable.vue';
import { Button  } from 'ant-design-vue';
import overviewMixin from '@/mixins/overviewMixin';

export default {
    name: 'CustomerOverview',
    components: {
        AntButton: Button,
        CustomerTable,
    },
    mixins: [overviewMixin('customers')],
};
</script>

<style></style>
